import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { Sidebar } from 'primereact/sidebar';
import useApi from "../hooks/ApiHook";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

export default function({
    inputClassName,
    placeholder,
    title,
    searchPath,
    searchParam,
    optionTemplate,
    valueTemplate,
    getKey,
    onChange,
    value
}) {

    const [ open, setOpen ] = useState(false);
    const [ searchQuery, setSearchQuery ] = useState('');
    const [ options, setOptions ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ page, setPage ] = useState({ n: 0 });
    const [ total, setTotal ] = useState(0);
    const api = useApi();

    useEffect(() => {
        if (!options.length) {
            retrieveData();
        }
    }, [open]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            setPage({ n: 0 });
            setOptions([]);
        }, 500);
        return () => clearTimeout(timeOutId);
    }, [searchQuery]);

    useEffect(() => {
        if (!loading) {
            retrieveData();
        }
    }, [page]);

    const retrieveData = () => {
        if (!open) return;
        setLoading(true);
        api.get(`${searchPath}?${searchParam}=${searchQuery}&limit=30&page=${page.n}`).then(({ data }) => {
            if (!page.n) {
                setOptions(data.data);
            } else {
                setOptions([ ...options, ...data.data ]);
            }
            setTotal(data.total);
        }).finally(() => setLoading(false));
    }

    const onScroll = ({ target }) => {
        const getMore = target.scrollTop + 100 > (target.scrollHeight - target.offsetHeight);
        if (getMore && total > options.length) {
            setPage({ n: page.n + 1 });
        }
    }

    const onSelect = item => {
        onChange(item);
        setOpen(false);
    }

    return (
        <>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search"/>
                <InputText 
                    readOnly
                    placeholder={placeholder || 'Buscar'}
                    onClick={() => setOpen(true)}
                    value={value && valueTemplate(value)}
                    className={`cursor-pointer ${inputClassName}`}/>
            </IconField>
            <Sidebar visible={open} position="right" onHide={() => setOpen(false)} className="md:w-30rem">
                <div className="h-full flex flex-column">
                    <h2>{title || 'Buscar'}</h2>
                    <IconField iconPosition="left">
                        {loading ? <InputIcon className="pi pi-spin pi-spinner"/> : <InputIcon className="pi pi-search"/>}
                        <InputText 
                            className="w-full" 
                            onChange={e => setSearchQuery(e.target.value)} 
                            value={searchQuery}/>
                    </IconField>
                    <div onScroll={onScroll} className="w-full flex-grow-1 mt-4 max-w-full flex-shrink-1 overflow-y-hidden overflow-y-scroll">
                        {options.map(o => (
                            <ListOption 
                                onClick={() => onSelect(o)}
                                value={o} 
                                template={optionTemplate} 
                                key={getKey(o)}
                                selected={value && getKey(o) === getKey(value)}/>
                        ))}
                    </div>
                </div>
            </Sidebar>
        </>
    );
}

const ListOption = ({ value, template, selected, onClick }) => {
    return (
        <div onClick={onClick} className={`p-3 cursor-pointer hover:surface-hover ${selected && 'bg-primary-reverse'}`}>
            {template(value)}
        </div>
    );
}